import { render, staticRenderFns } from "./OlabPackageProfile.vue?vue&type=template&id=63593ae8&"
import script from "./OlabPackageProfile.vue?vue&type=script&lang=js&"
export * from "./OlabPackageProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports